import { Deal, getDealSettings, StrapiID } from '@ca/common/types'
import useDeal, { useActiveDeal } from './useDeal'
import { useMemo } from 'react'

export const useCustomDealSettings = (deal?: Deal) => {
  return useMemo(() => {
    return getDealSettings(deal)
  }, [deal])
}

const useDealSettings = () => {
  const deal = useActiveDeal()
  return useCustomDealSettings(deal)
}

export const useDealSettingsById = (dealId?: StrapiID) => {
  const deal = useDeal(dealId)
  return useCustomDealSettings(deal)
}

export default useDealSettings
